class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.hero__slide')];
    this.dots = [...this.querySelectorAll('.hero__dot')];
    this.current = 0;
    this.total = this.slides.length;
    if (this.total < 2) return;

    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.autoplay = this.dataset.autoplay === 'true';

    this.querySelector('[data-slide-prev]')?.addEventListener('click', () => this.prev());
    this.querySelector('[data-slide-next]')?.addEventListener('click', () => this.next());
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.slide, 10)));
    });

    if (this.autoplay) this.startTimer();

    this.addEventListener('pointerenter', () => this.stopTimer());
    this.addEventListener('pointerleave', () => { if (this.autoplay) this.startTimer(); });
  }

  goTo(index) {
    if (index === this.current) return;
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');
    this.current = (index + this.total) % this.total;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
    this.resetTimer();
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  startTimer() { this.timer = setInterval(() => this.next(), this.speed); }
  stopTimer() { clearInterval(this.timer); }
  resetTimer() { this.stopTimer(); if (this.autoplay) this.startTimer(); }

  disconnectedCallback() { this.stopTimer(); }
}

customElements.define('hero-slideshow', HeroSlideshow);
